import List from "@/components/list";
import vue from "@/main.js";

const Table = args => {
  const RCSelectionChange =
    args.props.type === "sended"
      ? null
      : args.listeners["selection-change"] || function() {};

  function handleDelete({ row }) {
    vue.$emit("deletePush", row);
  }

  function handleResend({ row }) {
    vue.$emit("resendPush", row);
  }

  const Deal = ({ props: { vo } }) => {
    let dealConf = [
      ["icon-delete", "删除", () => handleDelete(vo), "push:delete"]
    ];
    if (args.props.type === "failure") {
      dealConf.push([
        "icon-resend",
        "再次发送",
        () => handleResend(vo),
        "push:resend"
      ]);
    }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  let AccountTableConfig =
    args.props.type === "sended"
      ? [
          {
            label: "推送内容",
            prop: "pushContent",
            minWidth: 150,
            showOverflowTooltip: true
          },
          {
            label: "接收人姓名",
            prop: "toUserName",
            minWidth: 130
          },
          {
            label: "手机号码",
            prop: "toMobile",
            minWidth: 130
          },
          {
            label: "所属单位",
            prop: "deptName",
            minWidth: 130,
            showOverflowTooltip: true
          },
          {
            label: "单位及职务",
            prop: "unitPosition",
            minWidth: 130
          },
          {
            label: "最后发送时间",
            prop: "pushSendDate",
            minWidth: 150,
            showOverflowTooltip: true
          }
        ]
      : [
          {
            type: "selection",
            label: "main"
          },
          {
            label: "推送内容",
            prop: "pushContent",
            minWidth: 150,
            showOverflowTooltip: true
          },
          {
            label: "接收人姓名",
            prop: "toUserName",
            minWidth: 130
          },
          {
            label: "手机号码",
            prop: "toMobile",
            minWidth: 130
          },
          {
            label: "所属单位",
            prop: "deptName",
            minWidth: 130,
            showOverflowTooltip: true
          },
          {
            label: "单位及职务",
            prop: "unitPosition",
            minWidth: 130
          },
          {
            label: "最后发送时间",
            prop: "pushSendDate",
            minWidth: 150,
            showOverflowTooltip: true
          },
          {
            label: "操作",
            minWidth: 120,
            render: vo => <Deal vo={vo} />
          }
        ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
